import { router, Stack } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';
import useVaroOnboardingFlow from 'shared/utils/useVaroOnboardingFlow/useVaroOnboardingFlow';

const TransferError = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'transferStrings',
  });

  const flow = useVaroOnboardingFlow();

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('errorText')}
        messageBody={translatedText('errorSubText')}
        primaryButton={{
          title: translatedText('tryAgainButton'),
          onPress: () => {
            router.replace(`/${flow}/transfer/transfer-money`);
          },
          analytics: {
            analyticsId: 'transferMoneyFlowError',
            customAttributes: {
              step_name: 'Transfer Money Request Submitted',
            },
          },
        }}
        secondaryButton={{
          title: translatedText('errorButton'),
          onPress: () => {
            if (router.canGoBack()) {
              router.back();
            }
          },
          analytics: {
            analyticsId: 'transferMoneyFlowError',
            customAttributes: {
              step_name: 'Transfer Money Request Submitted',
            },
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    paddingVertical: theme.spacing.m,
  },
});

export default TransferError;
